import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-announcements',
  templateUrl: './announcements.component.html',
  styleUrls: ['./announcements.component.scss']
})
export class AnnouncementsComponent implements OnInit {
 @Output() closeNotification: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(public router: Router) { }
  @Input() announcement;
  title: any;
  description: any;
  childName: any;
  id: number;
  ngOnInit(): void {
    this.id = this.announcement.id;
    this.title = this.announcement.title;
    this.description = this.announcement.description;
    this.childName = this.announcement.displayName;
  }

  close() {
    this.closeNotification.emit(false);
  }

  async showAnnouncement(announcementId) {
    await this.router.navigate(['home/announcement'], {queryParams: {id: announcementId}});
  }
}
